import React from 'react';
import ModeExcel from '../../stores/card/ModeExcel';
import CardStore from '../../stores/card';
import { observer } from 'mobx-react';
import { WeaLocaleProvider } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

interface ExcelTableCellDetailButtonsProps{
    card: CardStore;
    excel: ModeExcel;
}

@observer
export default class ExcelTableCellDetailButtons extends React.Component<ExcelTableCellDetailButtonsProps, any> {
    isclick = false;
    render() {
        const { card, excel } = this.props;
        const { params } = card;
        if (params.type == '0' || params.type == '1' || params.type == '2') {
            const { isOpensapmul = false, isAdd = false, isCopy = false, orderid = '', isDelete = false} = excel.detailProps;
            return (
                <div className={` ${params.type == '0' ? 'cube-detailbtn-edit' : ''}`} >
                    <div className={`detailButtonDiv`}>
                        {isOpensapmul && <i
                            id={`sapmulbutton${orderid}`}
                            {...{ name: `sapmulbutton${orderid}` }}
                            className="icon-coms-form-sap detailBtn"
                            title="sap"
                            onClick={this.addSapRow} />}
                        {isAdd && <i id={`addbutton${orderid}`} {...{ name: `addbutton${orderid}` }} className="icon-coms-Add-to detailBtn" title={getLabel(611, "添加")} onClick={this.addRow} />}
                        {isDelete && params.type!='2' && <i id={`delbutton${orderid}`} {...{ name: `delbutton${orderid}` }} className="icon-coms-form-delete detailBtn" title={getLabel(91, "删除")} onClick={this.delRow} />}
                        {params.type=='2' && <i id={`delbutton${orderid}`} {...{ name: `delbutton${orderid}` }} className="icon-coms-form-delete detailBtn" title={getLabel(91, "删除")} onClick={this.delRow} />}
                        {isCopy && <i id={`copybutton${orderid}`} {...{ name: `copybutton${orderid}` }} className="icon-coms-form-copy detailBtn" title={getLabel(77, "复制")} onClick={this.copyRow} />}
                    </div>
                </div>
            )
        }
        return (
            <div className="detailButtonDiv" style={{ width: "150px" }}>
            </div>
        )
    }
    addSapRow = () => {

    }
    addRow = () => {
        const { card, excel } = this.props;
        const { params } = card;
        const { orderid = '' } = excel.detailProps || {};
        card.cubeForm.addRow(orderid,params.type)
    }
    delRow = () => {
        const { card, excel } = this.props;
        const { params } = card;
        const { orderid = '' } = excel.detailProps || {};
        card.cubeForm.delRow(orderid,params.type)
    }
    copyRow = () => {
        if(!this.isclick){
            this.isclick = true;
            const { card, excel } = this.props;
            const { params } = card;
            const { orderid = '' } = excel.detailProps || {};
            card.cubeForm.copyRow(orderid,params.type);
            const _this = this;
            setTimeout(()=>{
                _this.isclick = false;
            },500) //500ms内仅能点击一次
        }
    }

}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/DetailButtons.tsx